import axios, { AxiosResponse } from 'axios';
import type { LoginRequest, RegisterRequest, LoginResponse, RegisterResponse } from '@/lib/auth';
 
const API_ROOT = process.env.VUE_APP_PROFILE_ROOT;
 
export const authService = {
  async login(data: LoginRequest): Promise<LoginResponse> {
    try {
        const res = await axios.post<LoginRequest, AxiosResponse<LoginResponse>>(
        `${API_ROOT}/auth/login`,
        data,
        { withCredentials: true }
      );
      return res.data;
    } catch (e: any) {
      console.warn('Login error:', e);
      return {
        success: false,
        error: e.response?.data?.error || 'Login failed',
      };
    }
  },
  async register(data: RegisterRequest): Promise<RegisterResponse> {
    try {
      const res = await axios.post<RegisterRequest, AxiosResponse<RegisterResponse>>(
        `${API_ROOT}/auth/register`,
        data,
        { withCredentials: true }
      );
      return res.data;
    } catch (e: any) {
      console.warn('Register error:', e);
      return {
        success: false,
        error: e.response?.data?.error || 'Registration failed',
      };
    }
  },
};